import moment from 'moment';

import { ACTIONS } from '@~/actions/event-notification';

const initialState = {
  eventType: null,
  eventData: {},
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.RECORD_EVENT_NOTIFICATION: {
      const { eventType, eventData, attributes = {} } = payload;

      return {
        eventType,
        eventData: {
          attributes,
          event_time: Number(moment()),
          ...eventData,
        },
      };
    }
    default:
      return state;
  }
}
